import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { CompanyButtonsWithProgramme } from 'pages/custom/shared/detail/CompanyButtonsWithProgramme';
import { OverflowFilters } from 'pages/custom/shared/overflow/OverflowFilters';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext } from 'react';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const GFestivalPage = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);

    function show(location: 'festival' | 'accomodation' | 'camping') {
        if (location === 'festival') {
            ctxView.mapRef?.current?.fitBounds([
                [-6.75488, 62.187015],
                [-6.751816, 62.185519]
            ]);
        } else if (location === 'accomodation') {
            ctxView.mapRef?.current?.fitBounds([
                [-6.748987, 62.193605],
                [-6.745281, 62.191395]
            ]);
        } else if (location === 'camping') {
            ctxView.mapRef?.current?.fitBounds([
                [-6.748759, 62.200888],
                [-6.741724, 62.196909]
            ]);
        }
    }

    return (
        <S_GFestivalPage className={props.className}>
            <CustomMapPage
                mapId={'b4f8a8fc-9b44-4883-b5bb-16257ea03a02'}
                highlightedStyle={''}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/173dbc98-91f1-4d7f-bd8c-d786194eaf7d.jpeg',
                    link: 'https://gfestival.fo/',
                    linkText: Localization.WEBSITE,
                    logoMarginTop: '0px',
                    logoText: 'G! Festival',
                    logoSubtext: '13-15 July 2023'
                }}
                controls={
                    <CompanyButtonsWithProgramme
                        listTitle="places"
                        hideHighlight={true}
                        programmeTitle="Programme (PDF)"
                        onProgrammeClicked={() => {
                            //redirect in new tab
                            window
                                .open(
                                    'https://drive.google.com/file/d/1AsIZe07er12ulDI0SMJTtrR0GjpfwZfU/view?usp=sharing',
                                    '_blank'
                                )
                                ?.focus();
                        }}
                    />
                }
                topOverflow={
                    <OverflowFilters
                        items={[
                            {
                                iconName: 'party-horn',
                                text: 'Syðrugøta',
                                onClick: () => {
                                    show('festival');
                                }
                            },
                            {
                                iconName: 'hotel',
                                text: 'Gøtugjógv',
                                onClick: () => {
                                    show('accomodation');
                                }
                            },
                            {
                                iconName: 'campground',
                                text: 'Norðragøta',
                                onClick: () => {
                                    show('camping');
                                }
                            }
                        ]}
                    />
                }
            />
        </S_GFestivalPage>
    );
};

const S_GFestivalPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
    position: relative;
`;
